export const RECEIVED_ACTIVITIES = 'RECEIVED_ACTIVITIES';

const activityExists = window.activities ? window.activities : [];

const getActivities = () => (
    (dispatch) => {
        dispatch({
            type: RECEIVED_ACTIVITIES,
            activities: activityExists,
        });
    }
);

export default getActivities;
